import { createFileRoute } from "@tanstack/react-router";

/**
 * Customer self-serve "Add Agent" wizard route (CLA-611).
 *
 * Eagerly registers `/clawinstall/dashboard/agents/new`; the wizard component is
 * deferred to `new.lazy.tsx` so its chunk (Stripe.js + the provisioning stream)
 * stays out of the main bundle. The static `new` segment takes precedence over
 * the sibling `$agentId` dynamic route, so this never resolves as an agent id.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/dashboard/agents/new")({});
